import React from "react";
import {
  Image,
  Grid,
  Menu,
  Container,
  Transition,
  Button,
  Responsive,
  Icon
} from "semantic-ui-react";
import Slider from "react-slick";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
/*import {
  GetContent,
  GetImageFromContent,
  GetTextFromContent,
  GetSlider,
  GetRichTextFromContent
} from "../scripts";*/
import API, { mainIp } from "../API/API";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import MenuItems from "../components/MenuItems";
import ImageLoading from "./ImageLoading";
import { image1 } from "../assets/Assets";
const menu = [
  { id: 1, name: "Cancún", navigateto: "/cancun" },
  { id: 2, name: "Metepec", navigateto: "/metepec" },
  { id: 3, name: "Monterrey", navigateto: "/monterrey" },
  { id: 4, name: "Veracruz", navigateto: "/veracruz" },
  { id: 5, name: "Acapulco", navigateto: "/acapulco" },
  { id: 6, name: "Cocoyoc", navigateto: "/cocoyoc" }
];

const marginForArrows = "2.5rem";
const marginForArrowsMobile = "0.6rem";
class SliderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.dickref = React.createRef();
    this.state = { activeItem: "Inicio", value: 0, mobileMenuVisible: false };
    this._menu = [];
    this.imagesSplash = [];
    this.finalImages = [];

    this.renderArrows = this.renderArrows.bind(this);
  }

  componentDidMount() {
    menu.forEach((nav, key) => {
      this._menu.push({ text: nav.name, value: key });
    });
    if (this.sliderDesktop !== undefined) {
      setTimeout(() => {
        if (this.sliderDesktop !== undefined && this.sliderDesktop !== null) {
          this.sliderDesktop.slickGoTo(0, false);
        }
      }, 400);
    }

    if (this.sliderTablet !== undefined) {
      setTimeout(() => {
        if (this.sliderTablet !== undefined && this.sliderTablet !== null) {
          this.sliderTablet.slickGoTo(0, false);
        }
      }, 400);
    }
  }

  onChange = (e, data) => {
    this.setState({ value: data.value });
    this.props.push(menu[data.value].navigateto);
  };

  renderArrows(checkRef, marginForArrows, marginTop, width, height, size) {
    return (
      <div
        align={"center"}
        style={{
          width: "100%",
          height: "100vh",
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "center"
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            alignSelf: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              height: height,
              width: width,
              marginBottom: marginTop,
              marginLeft: marginForArrows,
              zIndex: 100,
              backgroundColor: "#FFFFFF",
              justifyContent: "center"
            }}
            onClick={() => {
              if (this.sliderDesktop !== undefined) {
                this.sliderDesktop.slickPrev();
              }
            }}
          >
            <Icon
              name="chevron left"
              size={size}
              style={{ color: "#002A6B", alignSelf: "center" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              height: height,
              width: width,
              marginBottom: marginTop,
              marginRight: marginForArrows,
              zIndex: 100,
              backgroundColor: "#FFFFFF",
              justifyContent: "center"
            }}
            onClick={() => {
              if (this.sliderDesktop !== undefined) {
                this.sliderDesktop.slickNext();
              }
            }}
          >
            <Icon
              name="chevron right"
              size={size}
              style={{ color: "#002A6B", alignSelf: "center" }}/>
          </div>
        </div>
      </div>
    );
  }

  renderInDesktop() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      arrows: false,
      fade: true
    };

    return (
      <div style={{ backgroundColor: "#5F95B7" }}>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderArrows(
            this.sliderDesktop,
            marginForArrows,
            0,
            "3rem",
            "7rem",
            "large"
          )}
        </Responsive>
        <Slider ref={c => (this.sliderDesktop = c)} {...settings}>
          {this.props.menuitems.map((data, index) => {
            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  height: "100vh"
                }}
              >
                <div>
                  <div
                    style={{
                      backgroundImage:
                        "url(" + mainIp + data.homeImage.result + ")"
                    }}
                    className="splashBg"
                  >
                    <div
                      style={{
                        backgroundColor: "rgba(0,0,0,0.15)",
                        height: "100vh"
                      }}
                    >
                      <Container style={{ height: "100vh" }}>
                        <div style={{ height: "100vh" }}>
                          <div style={{}} className="logoContainer">
                            <Image
                              src={mainIp + data.logo.result}
                              width="155"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignSelf: "center"
                              }}
                            />
                          </div>
                          <div className="headingContainer">
                            <h1 className="headingSplash shadow">
                              {data.name}
                            </h1>
                            <Responsive {...Responsive.onlyMobile}>
                              <h3
                                style={{
                                  color: "white",
                                  overflow: "hidden",
                                  maxHeight: "5rem"
                                }}
                                className="headingSub shadow"
                              >
                                {data.homeDesc}
                              </h3>  
                            </Responsive>
                            <Responsive {...Responsive.onlyComputer}>
                              <h3
                                style={{
                                  color: "white",
                                  overflow: "hidden",
                                  maxHeight: "10rem"
                                }}
                                className="headingSub shadow"
                              >
                                {data.homeDesc}
                              </h3>
                            </Responsive>
                            
                          </div>
                        </div>
                      </Container>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>

        <div
          style={{
            color: "white",
            position: "absolute",
            display: "grid",
            justifyContent: "center",
            bottom: "4.5vh",
            width: "100%",
            textAlign: "center"
          }}
        >
          <label>contacto@ara.com.mx</label>
          <p>
            Llámanos:{" "}
            <label style={{ fontWeight: "bold" }}>01-800-022-0581</label>
          </p>
        </div>
        <div style={{}} className="mainMenuContainer">
          <Menu
            widths={this.props.developments.length}
            stackable
            className="mainMenu"
          >
            {this.props.developments.map(item => {
              return (
                <Menu.Item
                  id={item.id}
                  className="mainMenuItem"
                  style={{ textTransform: "uppercase" }}
                  onClick={() => {
                    this.props.push("/" + item.url);
                  }}
                >
                  {item.name}
                </Menu.Item>
              );
            })}
          </Menu>
        </div>

        <Button
          style={{
            cursor: "pointer"
          }}
          className="DButtonInv mobileNav"
          onClick={() => {
            this.setState({
              mobileMenuVisible: !this.state.mobileMenuVisible
            });
          }}
        >
          MENU
        </Button>

        <Transition
          visible={this.state.mobileMenuVisible}
          animation="fade"
          duration={300}
        >
          <div className="menum" align="center">
            <MenuItems
              onClickMobileMenu={() => {
                this.setState({
                  mobileMenuVisible: !this.state.mobileMenuVisible
                });
              }}
              listitem={this.props.developments}
            />
          </div>
        </Transition>
      </div>
    );
  }

  renderInTablet() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true
    };
    return (
      <div>
        <Slider ref={c => (this.sliderTablet = c)} {...settings}>
          {this.props.menuitems.map((data, index) => {
            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  height: "100vh"
                }}
              >
                <div
                  style={{
                    backgroundImage:
                      "url(" + mainIp + data.homeImage.result + ")"
                  }}
                  className="splashBg"
                >
                  <div
                    style={{
                      backgroundColor: "rgba(0,0,0,0.15)",
                      height: "100vh"
                    }}
                  >
                    <Container style={{ height: "100vh" }}>
                      <Grid
                        stackable
                        columns={2}
                        style={{
                          zIndex: "999",
                          margin: 0,
                          padding: 0
                        }}
                      >
                        <Grid.Row
                          align="left"
                          style={{ padding: 0, margin: 0 }}
                        >
                          <div style={{}} className="logoContainer">
                            <Image
                              src={mainIp + data.logo.result}
                              width="140"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignSelf: "center"
                              }}
                            />
                          </div>
                        </Grid.Row>

                        <Grid.Row
                          align="left"
                          style={{ padding: 0, margin: 0 }}
                        >
                          <h1 className="headingSplash shadow">{data.name}</h1>
                          <h3
                            style={{
                              color: "white",
                              overflow: "hidden",
                              maxHeight: "7rem"
                            }}
                            className="headingSub shadow"
                          >
                            {data.homeDesc}
                          </h3>
                        </Grid.Row>
                      </Grid>
                      <div
                        style={{
                          marginBottom: "10rem"
                        }}
                      />
                    </Container>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>

        <div
          style={{
            color: "white",
            position: "absolute",
            display: "grid",
            justifyContent: "center",
            bottom: "5vh",
            width: "100%",
            textAlign: "center"
          }}
        >
          <label>contacto@ara.com.mx</label>
          <p>
            Llámanos:
            <label style={{ fontWeight: "bold" }}>01-800-022-0581</label>
          </p>
        </div>

        <Menu
          widths={this.props.developments.length}
          style={{ position: "absolute", top: "33rem" }}
          stackable
        >
          {this.props.developments.map(item => {
            return (
              <Menu.Item
                key={item.id}
                className="mainMenuItem"
                style={{ textTransform: "uppercase" }}
                onClick={() => {
                  this.props.push("/" + item.url);
                }}
              >
                {item.name}
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

const mapStateToProps = ({ data }) => {
  const { pages, currentlanguage, developments } = data;
  return {
    pages,
    currentlanguage,
    developments
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SliderComponent)
);
